import { createSlice } from "@reduxjs/toolkit";
import { LOADING } from "../../../types";
import { FaqState } from "../types/state";
import { setFaqError } from "../actions/setError";
import { setFaqData } from "../actions/setData";
import { addFaq } from "../actions/add";
import { deleteFaq } from "../actions/delete";
import { toggleFaqVisibility } from "../actions/toggleVisibility";

const initialState: FaqState = {
  data: null,
  loading: LOADING.IDLE,
  error: null,
};

export const faqSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setFaqError, (state, { payload: error }) => {
        state.error = error;
        state.loading = LOADING.IDLE;
        state.data = null;
      })
      .addCase(setFaqData, (state, { payload: sponsors }) => {
        state.data = sponsors;
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addFaq.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addFaq.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(addFaq.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(deleteFaq.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(deleteFaq.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(deleteFaq.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(toggleFaqVisibility.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(toggleFaqVisibility.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(toggleFaqVisibility.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      });
  },
});
